<div
    class="group/item relative print:border-primary print:border-2 rounded-2xl overflow-hidden bg-clip-border h-full transition-all duration-300"
    [class]="customClass()"
    [class.cursor-pointer]="hasLink()"
    [class.p-6]="!isComplex()"
    [class.hover:scale-105]="isComplex() && hasLink()"
    [class.[&:has(:focus-visible)]:outline-4]="hasLink()"
    [class.dark:hover:bg-primary-400]="!isComplex() && hasLink()"
    [class.hover:bg-primary-100]="!isComplex() && hasLink()">
    <ng-content />
</div>
